export function TopRightMenuItem({ children }: { children: React.ReactNode }) {
  return (
    <div className="ms-3" style={{ display: 'inline-block' }}>
      {children}
    </div>
  );
}
